import { ShieldCheck, IdCard, UserCheck, Lock } from "lucide-react";

export default function Safety() {
  return (
    <div data-testid="safety-page">
      {/* Hero */}
      <section className="relative bg-black text-cream overflow-hidden">
        <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "radial-gradient(circle at 30% 20%, #c9a34e 0%, transparent 50%)" }} />
        <div className="relative max-w-5xl mx-auto px-6 py-24 md:py-32">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-widest gold border border-gold/40 rounded-full px-4 py-1.5">
            <ShieldCheck size={14} strokeWidth={1.5} /> Trust & safety
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl mt-6 max-w-3xl leading-tight">
            Your safety <span className="gold italic">comes first.</span>
          </h1>
          <p className="text-lg text-cream/80 mt-6 max-w-2xl leading-relaxed">
            At Offline &amp; Available, creating a safe, comfortable environment is one of our highest priorities.
          </p>
        </div>
      </section>

      {/* Body */}
      <section className="max-w-3xl mx-auto px-6 py-20">
        <div className="space-y-8 text-neutral-800 leading-relaxed">
          <p>
            To help protect all attendees, every guest is required to register using their <strong>legal first and last name</strong>. Nicknames, aliases, or false names are not permitted during registration.
          </p>
          <p>
            Upon arrival, all attendees must present a <strong>valid government-issued photo ID</strong>. Your ID will be verified against the name on your registration and ticket before entry is granted.
          </p>

          <div className="text-eyebrow gold pt-6">These measures help us</div>
          <ul className="space-y-4">
            <li className="flex gap-4 items-start">
              <UserCheck size={22} strokeWidth={1.5} className="gold shrink-0 mt-0.5" />
              <div>
                <div className="font-heading text-xl">Verify every attendee</div>
                <p className="text-neutral-600 mt-1">Confirm that everyone in the room is exactly who they say they are.</p>
              </div>
            </li>
            <li className="flex gap-4 items-start">
              <IdCard size={22} strokeWidth={1.5} className="gold shrink-0 mt-0.5" />
              <div>
                <div className="font-heading text-xl">Prevent fraud and ticket transfers</div>
                <p className="text-neutral-600 mt-1">Tickets are non-transferable so bad actors can't slip through under someone else's name.</p>
              </div>
            </li>
            <li className="flex gap-4 items-start">
              <ShieldCheck size={22} strokeWidth={1.5} className="gold shrink-0 mt-0.5" />
              <div>
                <div className="font-heading text-xl">Create a safer, more trustworthy experience</div>
                <p className="text-neutral-600 mt-1">A vetted room is a relaxed room. Meaningful connection happens when guests feel safe.</p>
              </div>
            </li>
          </ul>

          <p className="pt-4">
            We appreciate your cooperation in helping us build a community where meaningful connections can happen with confidence.
          </p>
        </div>

        {/* Privacy notice */}
        <div className="mt-16 rounded-2xl bg-blush/50 border border-neutral-200 p-6 flex gap-4 items-start" data-testid="safety-privacy-notice">
          <Lock size={22} strokeWidth={1.5} className="gold shrink-0 mt-0.5" />
          <div>
            <div className="text-eyebrow">Privacy notice</div>
            <p className="text-neutral-700 text-sm mt-2 leading-relaxed">
              Your identification is used solely for entry verification and safety purposes. We do not share or sell your personal information.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
